import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const ComplaintRoutes = ({
  BCTongHop,
  BCSoSanh,
}: {
  BCTongHop: React.ComponentType;
  BCSoSanh: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.WARRANTY_COMPLAINT.BC_TH_3_MIEN.BASE} element={<BCTongHop />} />
    <Route path={ROUTES.WARRANTY_COMPLAINT.BC_SS_3_MIEN.BASE} element={<BCSoSanh />} />
  </Routes>
);
